import React, { useContext, useEffect, useState } from "react";
import { adminService } from "../../_services/admin.service";
import { connect } from "react-redux";
import { Card, PageHeader, Rate, Space, Table } from "antd";
import { LanguageContext } from "../../context/LanguageContext";
import moment from "moment";

const SuggestionFeedback = () => {
  const { t } = useContext(LanguageContext);
  const [data, setData] = useState([]);
  const getHelpDesk = () => {
    adminService.getHelpDesk().then((res) => {
      setData(res.data);
    });
  };

  useEffect(() => {
    getHelpDesk();
  }, []);

  const columnsData = [
    {
      title: t("sr.no"),
      dataIndex: "key",
      key: "key",
      render: (text, record, index) => index + 1,
    },
    {
      title: t("type"),
      dataIndex: "type",
      key: "type",
    },
    { title: t("name"), dataIndex: "user_name", key: "user_name" },
    {
      title: t("role"),
      dataIndex: "role",
      key: "role",
      render: (text, record) => (
        <Space size="middle" title={record?.id} style={{ maxWidth: 300 }}>
          {record.user_role === "4"
            ? "Admin"
            : record.user_role === "2"
            ? "Police Side"
            : "Officer Side"}
        </Space>
      ),
    },
    {
      title: t("suggestion_feedback"),
      dataIndex: "feedback",
      key: "feedback",
      render: (text, record) => (
        <Space size="middle" title={record?.id} style={{ maxWidth: 300 }}>
          {record.feedback ? record.feedback : record.suggestion}
        </Space>
      ),
    },
    {
      title: t("rating"),
      dataIndex: "feedback",
      key: "feedback",
      render: (text, record) => <Rate value={record.rating} />,
    },
    {
      title: t("date"),
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text, record) => (
        <p>{moment(record.createdAt).format("DD-MM-YYYY")}</p>
      ),
    },
  ];
  return (
    <>
      <Card>
        <PageHeader title="Suggestion/Feedback" />
        <Table dataSource={data} columns={columnsData} rowKey="id" />
      </Card>
    </>
  );
};

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  return {
    user,
    users,
    professionals,
  };
}
const connectedSuggestionFeedback =
  connect(mapStateToProps)(SuggestionFeedback);
export { connectedSuggestionFeedback as SuggestionFeedback };
